"use strict";

exports.__esModule = true;
exports.DataItemValueFields = DataItemValueFields;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
var _getDeviceDataItemStats = require("../../Device/common/getDeviceDataItemStats");
var _DeviceDataItemStatsSelector = require("../../Device/DeviceDataItemStatsSelector");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _Core = require("../../Core");
var _excluded = ["onChange", "value", "devices"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DataItemValueSelectorAdaptor = function DataItemValueSelectorAdaptor(_ref) {
  var onChange = _ref.onChange,
    value = _ref.value,
    devices = _ref.devices,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var stats = (0, _getDeviceDataItemStats.getDeviceDataItemStats)(devices);
  var selectedItem = value && stats.find(function (item) {
    return item.dataItemName === value;
  });
  return /*#__PURE__*/_react["default"].createElement(_DeviceDataItemStatsSelector.DeviceDataItemStatsSelector, _extends({
    onSelect: function onSelect(selected) {
      return onChange(selected.length > 0 ? selected[0].dataItemName : undefined);
    },
    selected: selectedItem ? [selectedItem] : [],
    items: stats
  }, extra));
};

/**
 * Fields for DataItemValueElement.
 */
function DataItemValueFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var timestampTypes = [{
    key: "timestamp",
    value: translate("DataItemValue.TimestampType.Timestamp", "Timestamp")
  }, {
    key: "receivedAt",
    value: translate("DataItemValue.TimestampType.ReceivedAt", "Received At")
  }];
  var timestampTypeSelected = timestampTypes.filter(function (v) {
    return v.key === element.props.timestampType;
  });
  return /*#__PURE__*/_react["default"].createElement(_DeviceListContext.DeviceListContext.Consumer, null, function (devices) {
    return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref2) {
      var translate = _ref2.translate;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("DataItem.dataItemName.label", "Data Item"),
        helperText: translate("DataItem.dataItemName.helperText", "Note: This widget will appear blank for devices without corresponding data items.")
      }, /*#__PURE__*/_react["default"].createElement(DataItemValueSelectorAdaptor, {
        value: element.props.dataItemName,
        onChange: function onChange(value) {
          return elementEditor.setProp(path, "dataItemName", value);
        },
        devices: devices
      })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("DataItemValueWidget.timestampType.label", "Timestamp")
      }, /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
        dataTestId: "timestampType-selector",
        getKey: function getKey(v) {
          return v.key;
        },
        renderItemText: function renderItemText(v) {
          return v.value;
        },
        selected: timestampTypeSelected.length > 0 ? timestampTypeSelected : [timestampTypes[0]],
        onSelect: function onSelect(selected) {
          if (selected && selected.length > 0) {
            elementEditor.setProp(path, "timestampType", selected[0].key);
          }
        },
        items: timestampTypes,
        width: 255
      })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("DataItem.dataItemDecimalPlaces.label", "Decimal places")
      }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
        clampValueOnBlur: true,
        min: 1,
        max: 10,
        stepSize: 1,
        minorStepSize: null,
        value: element.props.decimalPlacesString || element.props.decimalPlaces,
        onValueChange: function onValueChange(numberValue, stringValue) {
          var value = numberValue;
          if (stringValue === "") {
            value = undefined;
          } else if (value > 10) {
            value = 10;
          } else if (value < 1) {
            value = 1;
          }
          if (value) {
            value = Math.trunc(value);
          }
          elementEditor.setProps(path, {
            decimalPlaces: value,
            decimalPlacesString: stringValue
          });
        }
      })), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
        "data-testid": "hideLabel-selector",
        checked: element.props.hideLabel || false,
        label: translate("DataItem.hideLabel.label", "Hide Label"),
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "hideLabel", e.target.checked);
        }
      }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
        "data-testid": "hideTimestamp-selector",
        checked: element.props.hideTimestamp || false,
        label: translate("DataItem.hideTimestamp.label", "Hide Timestamp"),
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "hideTimestamp", e.target.checked);
        }
      }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
        "data-testid": "hideMtcAgentUnits-selector",
        checked: element.props.hideMtcAgentUnits || false,
        label: translate("DataItem.hideMtcAgentUnits.label", "Hide MTC Agent Units"),
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "hideMtcAgentUnits", e.target.checked);
        }
      }));
    });
  });
}